<template>
    <v-layout>
        <v-dialog v-model="mfiles.dialog" persistent scrollable width="30%">
            <v-card :loading="mfiles.loading">
                <template slot="progress">
                    <v-progress-linear color="amber darken-2" indeterminate></v-progress-linear>
                </template>
                <v-toolbar color="primary">
                    <v-toolbar-title style="color: white">{{$t('json.mfiles')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark :disabled="disabled || isDownloading" icon @click="refresh"><v-icon>mdi-cloud-refresh</v-icon></v-btn>
                </v-toolbar>
                <v-card-text style="max-height: 500px;">
                    <v-list two-line :disabled="disabled">
                      <template v-for="(file, index) in mfiles.files">
                        <v-list-item :key="file.Name">
                          <v-list-item-content>
                            <v-list-item-title v-text="file.Name"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="index < mfiles.files.length - 1" :key="index"></v-divider>
                      </template>
                        <!-- <v-list-item-group v-model="selectedIndex" multiple active-class="blue--text">
                            <template v-for="(file, index) in mfiles.files">
                                <v-list-item :key="file.Name">
                                    <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="file.Name"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon v-if="!active" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else color="blue darken-3">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                  </template>
                                </v-list-item>
                                <v-divider v-if="index < mfiles.files.length - 1" :key="index"></v-divider>
                            </template>
                        </v-list-item-group> -->
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="mfiles.dialog = false">{{$t('json.mfiles_close')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="disabled || isDownloading || mfiles.files.length === 0" color="primary" text @click="download">{{$t('json.mfiles_down')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import Models from '@/Models'
export default {
  name: 'MFilesDialog',
  props: ['mfiles', 'ws', 'disabled', 'app'], // app is "this" from APP.vue file
  data () {
    return {
      selectedIndex: []
    }
  },
  computed: {
    isDownloading () {
      return this.app.mfilesDownloading
    }
  },
  methods: {
    refresh (ev = null, loading = false) {
      console.log('DIALOG refresh mfiles....')
      this.mfiles.loading = true
      const action = Models.Action
      action.TYPE = Models.ActionType.MFILES
      // eslint-disable-next-line no-unneeded-ternary
      action.MFilesOnlyList = (ev !== null) ? true : false
      action.Device = this.app.twain.Device
      action.DocClass = null
      action.SessionId = this.app.batchUploadProfil.SessionId
      action.BatchTypes = this.app.batchTypes
      if (loading) this.app.mfilesDownloading = true
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.MFILES)
    },
    async download () {
      console.log('DIALOG donwload mfiles...')
      this.mfiles.loading = true
      const action = Models.Action
      action.TYPE = Models.ActionType.MFILES_DOWNLOAD
      console.log(this.app)
      action.Device = this.app.twain.Device
      action.DocClass = null
      action.SessionId = this.app.batchUploadProfil.SessionId
      action.BatchTypes = this.app.batchTypes
      action.MFiles = this.mfiles.files
      this.ws._send(JSON.stringify(action))
      this.$swsa.emitClick(Models.ActionType.MFILES_DOWNLOAD)
    }
  },
  mounted () {
    /* window.setTimeout(() => {
      this.refresh()
    }, 2000) */
  },
  watch: {
    'mfiles.files': function (newVal) {
      this.selectedIndex = []
    },
    selectedIndex: function (newVal) {
      console.log(newVal)
      this.mfiles.files.forEach((f) => { f.Selected = false })
      newVal.forEach(i => {
        const f = this.mfiles.files[i]
        f.Selected = true
      })
    }
  }
}
</script>
